import React from 'react'
import '../assets/style/projects.css'
import { projectData } from '../utils/constants'

const ProjectCard = ({ image, title, description, technologies }) => {
    return (
        <div className="row pf-row align-items-center">
            <div className="col-12 col-md-6 p-0">
                <img src={image} alt={title} className='w-100 project-img' />
            </div>

            <div className="col-12 col-md-6 ps-md-4 mt-4 mt-md-0">
                <h2>{title}</h2>

                <p>{description}</p>

                <h4>Technologies</h4>

                <div className="tech-stack">
                    {technologies.map((tech, index) => (
                        <span key={index}>{tech}, </span>
                    ))}
                </div>
            </div>
        </div>
    )
}

const Projects = () => {
    return (
        <div className="projects">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">

                        <h2 className='pj-heading'>My Latest Projects</h2>

                        <p className='mb-5 py-2'>
                            Projects that I have designed and developed using modern frontend,
                            full stack, and WordPress technologies.
                        </p>

                        {projectData.map((project) => (
                            <ProjectCard
                                key={project.id}
                                image={project.image}
                                title={project.title}
                                description={project.description}
                                technologies={project.technologies}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Projects